import React from 'react';
import { withFormulas } from '../hocs/with-formulas';
import { ScoreContent, ScoreSubcomponents } from '../components';


export const ScoreResilience = ({formulas, className}) => {
  const costTitle = "Resilience";
  const costSummary = "Resiliency measures the ability of your business to mitigate factors that are outside of your direct control and how likely your business can withstand sudden and prolonged changes."
  const getStarted = () => {
    window.open('https://www.paystand.com/ar-health-consult','_blank','resizable=yes');
  }
  return (
    <ScoreContent title={costTitle} summary={costSummary} className={className}>
      <div className="print--only-visible">
        <img src={require(`../../styles/img/${formulas.getResilienceScore()}_score.png`)} style={{width: "55px"}} alt="score-a"/>
      </div>
      <div className="health-graph">
        <ScoreSubcomponents title="Manual to Digital Spectrum" health={formulas.getDigitalSpectrumHealth()}/>
        <ScoreSubcomponents title="Dependent to Autonomous Spectrum" health={formulas.getControlSpectrumHealth()}/>
      </div>
      <div className="info">
        <span className="text-02-navy-blue">Recommended Reading</span>
        <p className="text-04-navy-blue-bold">Here are some helpful resources for building a more resilient, capital-efficient Accounts Receivable process.</p>
        <a className="text-04-sky-blue" href="https://www.paystand.com/blog/how-b2b-businesses-can-protect-and-grow-revenue-during-economic-downturn" target="_blank" rel="noopener noreferrer">
          How to Recession-Proof Accounts Receivable
        </a>
        <a className="text-04-sky-blue" href="https://www.paystand.com/blog/the-four-pillars-of-modern-b2b-payments" target="_blank" rel="noopener noreferrer">
          4 Pillars of Modern B2B Payments
        </a>
        <a  className="text-04-sky-blue" href="https://www.paystand.com/resources/whitepapers/controllers-guide-b2b-payment-optimization" target="_blank" rel="noopener noreferrer">
          Guide To B2B Payment Optimization
        </a>
        <span className="text-02-navy-blue-bold">Ready to build a more resilient payments process?</span>
        <button onClick={getStarted}>Schedule A Consult</button>
      </div>
    </ScoreContent>
  )
}

export const ScoreResilienceWithFormulas = withFormulas(ScoreResilience);